import { TypedEmitter } from '../../events';
export class SSAIManager extends TypedEmitter {
}
